// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-modal-container .header {
  width: 100%;
  border: none;
  padding: 16px;
  cursor: pointer;
  border-radius: 4px;
}
.accordion-modal-container .header .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.accordion-modal-container .header .header-content img {
  height: 8px;
  width: 16px;
}
.accordion-modal-container .header .header-content img.rotate-down {
  transform: rotate(180deg);
}
.accordion-modal-container .header .header-content img.rotate-up {
  transform: rotate(0deg);
}
.accordion-modal-container .header .header-content-left {
  gap: 9.58px;
  display: flex;
  font-weight: 700;
  align-items: center;
  color: var(--sebrae-blue-6);
}
.accordion-modal-container .header .header-content-left p {
  font-size: 13px;
}
.accordion-modal-container .header .header-content-left img {
  width: 15px;
  height: 15px;
}
.accordion-modal-container .panel {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}
.accordion-modal-container .panel.open {
  max-height: 1000px;
}
.accordion-modal-container .panel.closed {
  max-height: 0;
}
.accordion-modal-container .panel .example {
  padding: 0 16px 16px;
  font-size: 13px;
}
.accordion-modal-container .panel .example img {
  margin-bottom: 10px;
}
.accordion-modal-container .panel .example span {
  font-weight: 700;
}
.accordion-modal-container .panel .example.first {
  margin-bottom: 24px;
}
.accordion-modal-container .panel .example .example-list {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 8px;
}
.accordion-modal-container .panel .example .example-list li {
  line-height: 1.2;
}
.accordion-modal-container .panel .example .example-list li strong {
  font-weight: 600;
}
@media (min-width: 1024px) {
  .accordion-modal-container .header .header-content-left p {
    font-size: 16px;
  }
  .accordion-modal-container .panel {
    display: flex;
  }
  .accordion-modal-container .panel .example {
    gap: 8px;
    display: flex;
  }
  .accordion-modal-container .panel .example img {
    width: auto;
    height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/accordion-modal/index.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAN;AAEM;EACE,WAAA;EACA,WAAA;AAAR;AAEQ;EACE,yBAAA;AAAV;AAGQ;EACE,uBAAA;AADV;AAKM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AAHR;AAKQ;EACE,eAAA;AAHV;AAMQ;EACE,WAAA;EACA,YAAA;AAJV;AAUE;EACE,gBAAA;EACA,aAAA;EACA,gCAAA;AARJ;AAUI;EACE,kBAAA;AARN;AAWI;EACE,aAAA;AATN;AAYI;EACE,oBAAA;EACA,eAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAaM;EACE,gBAAA;AAXR;AAcM;EACE,mBAAA;AAZR;AAeM;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AAbR;AAeQ;EACE,gBAAA;AAbV;AAeU;EACE,gBAAA;AAbZ;AAoBE;EAIQ;IACE,eAAA;EArBV;EA2BE;IACE,aAAA;EAzBJ;EA2BI;IACE,QAAA;IACA,aAAA;EAzBN;EA2BM;IACE,WAAA;IACA,YAAA;EAzBR;AACF","sourcesContent":[".accordion-modal-container {\n  .header {\n    width: 100%;\n    border: none;\n    padding: 16px;\n    cursor: pointer;\n    border-radius: 4px;\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      img {\n        height: 8px;\n        width: 16px;\n\n        &.rotate-down {\n          transform: rotate(180deg);\n        }\n\n        &.rotate-up {\n          transform: rotate(0deg);\n        }\n      }\n\n      &-left {\n        gap: 9.58px;\n        display: flex;\n        font-weight: 700;\n        align-items: center;\n        color: var(--sebrae-blue-6);\n\n        p {\n          font-size: 13px;\n        }\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n  }\n\n  .panel {\n    overflow: hidden;\n    max-height: 0;\n    transition: max-height 0.3s ease;\n\n    &.open {\n      max-height: 1000px;\n    }\n\n    &.closed {\n      max-height: 0;\n    }\n\n    .example {\n      padding: 0 16px 16px;\n      font-size: 13px;\n\n      img {\n        margin-bottom: 10px;\n      }\n\n      span {\n        font-weight: 700;\n      }\n\n      &.first {\n        margin-bottom: 24px;\n      }\n\n      .example-list {\n        list-style-type: disc;\n        padding-left: 20px;\n        margin-top: 8px;\n\n        li {\n          line-height: 1.2;\n\n          strong {\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .header {\n      .header-content {\n        &-left {\n          p {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    .panel {\n      display: flex;\n\n      .example {\n        gap: 8px;\n        display: flex;\n\n        img {\n          width: auto;\n          height: 18px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
